import type React from 'react';
import { AuthFormLayout } from '@/components/molecules';
import type { StageProps } from '../types';

export const SubscriptionStage: React.FC<StageProps> = ({ error }) => {
  return (
    <AuthFormLayout title="Subscriptions" error={error}>
      <div className="h-64 flex items-center justify-center border border-dashed border-gray-600 rounded">
        <span className="text-gray-500">Subscription Options Coming Soon</span>
      </div>
    </AuthFormLayout>
  );
};
